import React from 'react';

import PropTypes from 'prop-types';
import { MdAccessTime } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { SingleConfirmationModal } from '@shared/components';

import { ProgressButton } from '../../../common';
import { openServiceHours } from '../../duck';
import ServiceHoursTabs from '../ServiceForm/ServiceHoursTabs';

class ServiceHoursButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.confirmModalRef = React.createRef();
  }

  handleClick = () => {
    const { askForConfirmation } = this.props;
    if (askForConfirmation) {
      this.openConfirmationModal();
    } else {
      this.openServiceHours();
    }
  };

  openServiceHours = () => {
    const { onOpenServiceHours, onClick } = this.props;
    onOpenServiceHours();
    onClick && onClick();
  };

  openConfirmationModal = () => {
    this.confirmModalRef.current.openConfirmationModal();
  };

  handleConfirm = () => {
    const { onConfirm } = this.props;
    this.openServiceHours();
    onConfirm && onConfirm();
  };

  handleCancel = () => {
    const { onCancel } = this.props;
    onCancel && onCancel();
  };

  render() {
    const {
      disabled,
      className,
      children,
      askForConfirmation,
      disableConfirmBtn,
      confirmationMessage,
      replaceButton,
    } = this.props;

    const button = replaceButton ? (
      React.cloneElement(replaceButton, { onClick: this.handleClick })
    ) : (
      <ProgressButton
        color="scouting-warm-gray"
        noBorder
        fitText
        disabled={disabled}
        icon={<MdAccessTime />}
        className={className}
        onClick={this.handleClick}
      >
        {children || <FormattedMessage id="service.ServiceHoursButton.label" />}
      </ProgressButton>
    );

    return (
      <React.Fragment>
        {askForConfirmation && (
          <SingleConfirmationModal
            ref={this.confirmModalRef}
            disableConfirm={disableConfirmBtn}
            confirmBtnText={<FormattedMessage id="shared.confirm" />}
            onCancel={this.handleCancel}
            message={confirmationMessage}
            onConfirm={this.handleConfirm}
          />
        )}
        {button}
      </React.Fragment>
    );
  }
}

const validateIfAskForConfirm =
  validator =>
  (props, ...args) => {
    if (props.askForConfirmation) {
      return validator(props, ...args);
    }
  };

ServiceHoursButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  userIds: PropTypes.array.isRequired,
  onClick: PropTypes.func,
  onOpenServiceHours: PropTypes.func.isRequired,
  askForConfirmation: PropTypes.bool,
  disableGetActivities: PropTypes.bool,
  disableFutureDays: PropTypes.bool,
  replaceButton: PropTypes.node,
  disableConfirmBtn: validateIfAskForConfirm(PropTypes.bool),
  confirmationMessage: validateIfAskForConfirm(
    PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  ),
  onCancel: validateIfAskForConfirm(PropTypes.func),
  onConfirm: validateIfAskForConfirm(PropTypes.func),
};

ServiceHoursTabs.defaultProps = {
  askForConfirmation: false,
};

const mapDispatch = (
  dispatch,
  { userIds, disableGetActivities, disableFutureDays },
) => ({
  onOpenServiceHours: () =>
    dispatch(
      openServiceHours(userIds, disableGetActivities, disableFutureDays),
    ),
});

export default connect(null, mapDispatch)(ServiceHoursButton);
